import { Placement } from "@floating-ui/react"
import { PropsWithChildren, useCallback, useState } from "react"
import { TransactionInfoBase } from "./TransactionInfoBase"
import { ITransactionInfo } from "@usher/pe-client-front-end-lib/dist/ExClient"
import { getApiDataPromise } from "@usher/pe-client-front-end-lib"

export const PayoutsTransactionInfo = ({
  title,
  children,
  placement,
  id,
}: {
  title: string
  id: string
  placement?: Placement
} & PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState(false)
  const [info, setInfo] = useState<ITransactionInfo | null>(null)

  const handleOpen = useCallback(() => {
    setIsLoading(true)

    getApiDataPromise({ transaction_id: id }, "exclient/cards", "get_card_payout_details")
      .then((res) => {
        // @ts-expect-error
        setInfo(res ?? null)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [id])

  return (
    <TransactionInfoBase isPayout placement={placement} info={info} isLoading={isLoading} title={title} onOpen={handleOpen}>
      {children}
    </TransactionInfoBase>
  )
}
